import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import {countertopGroupThumbnail} from "../assets";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
// import {PLACEMENTS} from "../constants";

import Sink from "../subparts/countertop/sink";
import Faucet from "../subparts/countertop/faucet";
import Countertop from "../subparts/countertop/countertop";
import EdgeProfile from "../subparts/countertop/edgeProfile";
import Cutouts from "../subparts/countertop/cutouts";
import Radius from "../subparts/countertop/radius";

export default class CountertopGroup extends Part {
  static id = 'Countertop';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Countertop';
    this.partThumbnail = countertopGroupThumbnail;
    this.translateId = "visualizer.kitchen.countertop";

    // related items
    this.sink = null;
    this.faucet = null;
    this.countertop = null;
    this.edgeProfile = null;
    this.relatedGroupNames = ["Faucet", "Sink", "Countertop", "Edge Profile", "Cutouts", "Radius"];
  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Sink":
      case "Farnhousesink":
        relatedItemName = "sink";
        RelatedItemClass = Sink;
        break;
      case "Faucet":
        relatedItemName = "faucet";
        RelatedItemClass = Faucet;
        break;
      case "Countertop":
        relatedItemName = "countertop";
        RelatedItemClass = Countertop;
        break;
      case "Edge Profile":
      case "Edge":
        relatedItemName = "edgeProfile";
        RelatedItemClass = EdgeProfile;
        break;
      case "Cutouts":
      case "cutouts":
        relatedItemName = "cutouts";
        RelatedItemClass = Cutouts;
        break;
      case "Radius":
        relatedItemName = "radius";
        RelatedItemClass = Radius;
        break;
    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature)
  }

  isSubTypeWithItems() {
    return false;
  }

  handleSubPartClick() {

  }

  subParts(withHidden = true, hideWithoutFeatures = false) {
    return this.getRelatedItems()
      .filter(item => {
        if (hideWithoutFeatures && (item.partId === "cutouts" || item.partId === "radius")) {
          return false
        }
        return this.filterRelatedItem(item, withHidden)
      })
      .map(_ => new DesignNavigationItem(_.partName, _));
  }

  setSpecificRules() {
    if (this.edgeProfile) {
      this.edgeProfile.setEdgeNotInVisualizer()
    }
  }

}
